<template>
  <div>
    <v-dialog v-model="isSavedModalOpen" width="99%" max-width="600">
      <v-card>
        <v-col align="center">
          <h2>Liste des états des lieux à synchroniser</h2>
        </v-col>
        <v-divider></v-divider>
        <v-col>
          <v-table>
            <thead>
              <tr>
                <th class="text-left" style="font-weight: bold">Contrat</th>
                <th class="text-left" style="font-weight: bold">Matricule</th>
                <th class="text-right" style="font-weight: bold">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in $store.state.storedData" :key="item.data.CLD_MATRICULE_UID">
                <td>{{ item.data.CLD_NUM_CONTRAT }}</td>
                <td>{{ item.data.CLD_MATRICULE }}</td>
                <td class="text-right">
                  <template v-if="syncDeleteIndex === index">
                    <v-icon color="green" class="mr-2" title="Confirmer la suppression"
                      @click="removeStoredEtadl(index)">mdi-check</v-icon>
                    <v-icon color="grey" title="Annuler"
                      @click="cancelRemoveStoredEtadl">mdi-close</v-icon>
                  </template>
                  <v-icon v-else color="red" title="Retirer de la liste à synchroniser"
                    @click="askRemoveStoredEtadl(index)">mdi-delete</v-icon>
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-col>
        <v-divider></v-divider>
        <v-btn color="#7986CB" style="color: white; border-radius: 0px; font-weight: bold"
          @click="sendSavedEtadlToServer">
          Synchroniser</v-btn>
      </v-card>
    </v-dialog>
    <v-dialog v-model="storageFullDialog" width="99%" max-width="480" persistent>
      <v-card>
        <v-col>
          <v-row align="center">
            <v-col cols="auto">
              <v-icon color="orange" size="40">mdi-database-alert</v-icon>
            </v-col>
            <v-col>
              <div style="font-weight: bold; font-size: 16px">Stockage local plein</div>
              <div style="font-size: 14px; color: grey; margin-top: 4px">
                Synchronisez vos états des lieux en attente avant de continuer.
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-divider></v-divider>
        <v-col class="px-0 pb-0">
          <v-btn block color="#7986CB" style="color: white; border-radius: 0px; font-weight: bold"
            @click="retrySaveAfterSync" :loading="isLoading">
            <v-icon class="mr-2">mdi-cloud-sync</v-icon>Synchroniser puis continuer
          </v-btn>
          <v-btn block variant="text" style="border-radius: 0px" @click="storageFullDialog = false">
            Annuler
          </v-btn>
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isVerifAll">
      <div align="center">
        <v-card width="95%" max-width="300px">
          <v-col style="font-weight: bold; font-size: 20px">
            Valider la suppression des éléments sélectionnés
          </v-col>
          <v-col class="px-0">
            <v-row>
              <v-col cols="6" class="px-0">
                <v-btn @click="valideSuppression" style="color: white" color="#E57373">
                  OUI
                </v-btn>
              </v-col>
              <v-col cols="6" class="px-0">
                <v-btn @click="isVerifAll = false" style="color: white" color="#5C6BC0">
                  NON
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="removeEtadlData.value">
      <div align="center">
        <v-card width="95%" max-width="300px">
          <v-col style="font-weight: bold; font-size: 20px">
            Valider la suppression
          </v-col>
          <v-col class="px-0">
            <v-row>
              <v-col cols="6" class="px-0">
                <v-btn @click="deleteEtadlValidation(removeEtadlData.data)" style="color: white" color="#E57373">
                  OUI
                </v-btn>
              </v-col>
              <v-col cols="6" class="px-0">
                <v-btn @click="removeEtadlData.value = false" style="color: white" color="#5C6BC0">
                  NON
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-if="isqCodeReaderOpen" v-model="isqCodeReaderOpen" width="99%" height="500" max-width="500">
      <v-card min-height="300">
        <qcode-reader :setMaterialList="setMaterialList"></qcode-reader>
      </v-card>
    </v-dialog>
    <v-dialog v-if="modalUser" v-model="modalUser" width="99%" max-width="500" persistent>
      <v-card height="80vh">
        <v-col>
          <modalUserDialog @close="modalUser = false" :agencyList="agency_list"
            :get_user_information="get_user_information" :isAdmin="isAdmin" />
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialog" v-model="dialog" fullscreen style="border-radius: 0px; z-index: 2">
      <div style="height: 100vh; overflow: auto; background-color: rgb(250, 250, 250)">
        <materielForm v-if="dialogData" :showErrorInContrat="etadlOptions.showErrorInContrat"
          :drawInObservation="etadlOptions.drawInObservation" :multipleSelection="etadlOptions.multipleSelection"
          :setSignataire="etadlOptions.setSignataire" :showTime="etadlOptions.showTime" :isAdmin="isAdmin"
          :parcListe="parcListe" :nbrMaxLoadedPhoto="etadlOptions.nbrMaxLoadedPhoto"
          :nbrMinLoadedPhoto="etadlOptions.nbrMinLoadedPhoto" :savedSignature="etadlOptions.savedSignature"
          :showStateData="etadlOptions.showStateData" :dialog="dialog" :data="dialogData" :clients_list="clients_list"
          :user_information="get_user_information" :agencyList="agency_list" :defaultForm="defaultForm"
          :defaultFormValues="defaultFormValues" :showSignByMail="etadlOptions.showSignByMail" @closeDialog="closeForm"
          :getNbrPhotoToLoad="getNbrPhotoToLoad" @pdfLoaded="nbrUploadDone = nbrUploadDone + 1"
          :nbrUploadDone="nbrUploadDone" @newMaterielForm="newMaterielForm($event)" />
      </div>
    </v-dialog>
    <div v-if="isLoading && materials_list != undefined && !syncProgress.active" style="
        position: fixed;
        background-color: rgb(0, 0, 0, 0.5);
        height: 100%;
        width: 100vw;
        z-index: 5;
        top: 0px;
        left: 0px;
      ">
      <v-col align="center" style="margin-top: 35vh">
        <v-progress-circular size="120" indeterminate color="white">Chargement</v-progress-circular>
      </v-col>
    </div>
    <!-- Overlay de synchronisation étape par étape -->
    <div v-if="syncProgress.active" style="
        position: fixed; top: 0; left: 0; height: 100%; width: 100vw;
        background-color: rgba(0, 0, 0, 0.55); z-index: 6;
        display: flex; align-items: center; justify-content: center;">
      <v-card width="92%" max-width="420" style="border-radius: 12px; overflow: hidden">
        <div style="background-color: #5C6BC0; color: white" class="pa-3">
          <div style="display: flex; align-items: center; gap: 8px">
            <v-progress-circular indeterminate size="22" width="3" color="white"></v-progress-circular>
            <span style="font-weight: bold; font-size: 16px">Synchronisation en cours</span>
          </div>
          <div style="font-size: 13px; opacity: 0.9; margin-top: 6px">
            État des lieux {{ syncProgress.current }} / {{ syncProgress.total }}
          </div>
          <v-progress-linear
            :model-value="syncProgress.total ? (syncProgress.current / syncProgress.total) * 100 : 0"
            color="white" bg-color="rgba(255,255,255,0.3)" height="6" rounded class="mt-2">
          </v-progress-linear>
        </div>
        <v-col class="pa-3">
          <div style="font-size: 13px; color: #616161; margin-bottom: 10px">
            <v-icon size="16" color="#5C6BC0" class="mr-1">mdi-file-document-outline</v-icon>
            Contrat <b>{{ syncProgress.contrat }}</b> · Matricule <b>{{ syncProgress.matricule }}</b>
          </div>
          <div v-if="syncProgress.steps && syncProgress.steps.length === 0"
            style="font-size: 14px; color: #90A4AE; padding: 5px 0">
            {{ syncProgress.stepLabel || 'Préparation…' }}
          </div>
          <div v-for="step in syncProgress.steps" :key="step.key"
            style="display: flex; align-items: center; gap: 10px; padding: 5px 0">
            <v-progress-circular v-if="step.status === 'active'" indeterminate size="18" width="2"
              color="#5C6BC0"></v-progress-circular>
            <v-icon v-else-if="step.status === 'done'" size="20" color="#66BB6A">mdi-check-circle</v-icon>
            <v-icon v-else size="20" color="#CFD8DC">mdi-circle-outline</v-icon>
            <span :style="{
              fontSize: '14px',
              color: step.status === 'pending' ? '#B0BEC5' : '#37474F',
              fontWeight: step.status === 'active' ? '600' : '400'
            }">{{ step.label }}</span>
          </div>
        </v-col>
      </v-card>
    </div>
    <v-col v-if="materials_list" class="pa-1 etat-des-lieux-materiel" align="center">
      <div style="position: absolute; z-index: 10; right: 10px; text-align: right">
        <!-- <v-btn v-if="isAdmin != 0" @click="modalUser = true" :color="textColor" icon="mdi-cog" size="small"
          variant="text">
        </v-btn> -->
        <v-btn @click="isqCodeReaderOpen = true" style="" color="black" icon="mdi-qrcode-scan" size="small"
          variant="text"></v-btn>
        <v-divider vertical class="mx-1"></v-divider>
        <v-btn @click="updateTable" style="" color="black" icon="mdi-refresh" size="small" variant="text"></v-btn>
        <v-tooltip v-if="storageUsage.quota > 0" location="bottom end" max-width="260">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" variant="text" size="small" style="min-width: 0; padding: 0 4px; font-size: 10px; opacity: 0.75"
              :color="storageUsage.percent > 85 ? '#F44336' : storageUsage.percent > 60 ? '#FF9800' : 'grey'">
              <v-icon size="13" class="mr-1">mdi-database</v-icon>{{ storageUsage.percent }}%
            </v-btn>
          </template>
          <div style="font-size: 13px; line-height: 2">
            <div style="font-weight: bold; font-size: 14px; margin-bottom: 2px">
              Stockage de l'application
            </div>
            <v-progress-linear
              :model-value="storageUsage.percent"
              :color="storageUsage.percent > 85 ? '#F44336' : storageUsage.percent > 60 ? '#FF9800' : '#66BB6A'"
              height="5"
              rounded
              bg-color="rgba(255,255,255,0.2)"
              style="margin-bottom: 6px"
            ></v-progress-linear>
            <div>
              <v-icon size="14" color="#EF9A9A">mdi-database-arrow-up</v-icon>
              Utilisé : <b>{{ formatBytes(storageUsage.usage) }}</b>
            </div>
            <div>
              <v-icon size="14" color="#A5D6A7">mdi-database-check</v-icon>
              Disponible : <b>{{ formatBytes(storageUsage.quota - storageUsage.usage) }}</b>
            </div>
            <div style="color: rgba(255,255,255,0.5); font-size: 11px">
              Total alloué : {{ formatBytes(storageUsage.quota) }}
            </div>
            <template v-if="$store.state.storedData && $store.state.storedData.length > 0">
              <v-divider style="margin: 6px 0; border-color: rgba(255,255,255,0.25)"></v-divider>
              <div style="color: #FFCC80">
                <v-icon size="14" color="#FFCC80">mdi-cloud-sync</v-icon>
                {{ $store.state.storedData.length }} état(s) en attente de sync
              </div>
              <div style="font-size: 11px; color: rgba(255,255,255,0.5)">
                Synchroniser libèrera de l'espace
              </div>
            </template>
          </div>
        </v-tooltip>
      </div>
      <v-card class="pa-2 mb-1" align="left" style="border-radius: 5px" color="white">
        <!-- Titre + alerte sync -->
        <v-col class="py-1 px-2">
          <v-row align="center" justify="start" no-gutters>
            <v-col cols="auto" style="font-size: 16px; font-weight: bold">
              Tableau de bord
            </v-col>
            <v-col v-if="$store.state.storedData && $store.state.storedData.length > 0" class="pl-2">
              <v-btn density="compact" @click="isSavedModalOpen = true" style="
                color: #ffcc80;
                background-color: #f44336;
                border: solid 1px orange;
                font-size: 12px;
                font-weight: bold;
              ">
                <v-icon size="16px" class="mr-1">mdi-alert</v-icon>
                {{ $store.state.storedData.length }} à synchroniser
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="$store.state.storedData && $store.state.storedData.length > 0" no-gutters class="mt-1">
            <v-col>
              <div style="font-size: 12px; color: #E53935; font-weight: 500">
                ⚠ Les données non synchronisées seront perdues à la déconnexion
              </div>
            </v-col>
          </v-row>
        </v-col>
        <!-- Filtres compacts -->
        <v-col class="pb-0 px-1">
          <v-row dense>
            <v-col cols="6" class="pa-1">
              <v-text-field variant="outlined" bg-color="#ECEFF1" density="compact" hide-details clearable
                label="Contrat / Client / Matricule" v-model="search"
                prepend-inner-icon="mdi-magnify"></v-text-field>
            </v-col>
            <v-col cols="6" class="pa-1">
              <!-- v-combobox et non v-autocomplete : la saisie libre est
                   acceptée, on peut donc filtrer sur un fragment (« 2KV »)
                   sans avoir à choisir une entrée complète de la liste. -->
              <v-combobox variant="outlined" bg-color="#ECEFF1" density="compact"
                label="Famille / Sous-famille"
                :items="getSubFamilly.concat(getFamilly)" v-model="selectedSubFamilly" hide-details
                style="text-transform: uppercase" no-data-text="Aucune famille"
                :menu-props="{ maxHeight: 400 }" clearable
                @update:search="rechercheFamille = $event">
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="6" class="pa-1">
              <v-select variant="outlined" v-if="itemsMenu" bg-color="#ECEFF1" label="Type de contrat"
                density="compact" hide-details style="text-transform: uppercase" :items="getItemsMenuFiltered"
                item-title="text" item-value="idx" v-model="selectedItem" multiple>
                <template v-slot:selection="{ item }">
                  <v-chip size="x-small" class="ma-1" variant="flat"
                    :class="itemsMenu[item.value].class" style="color: black; font-size: 11px">
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="technicienListe && technicienListe.length > 0" cols="12" sm="6" class="pa-1">
              <v-select variant="outlined" label="Technicien" bg-color="#ECEFF1" density="compact"
                v-model="selectedTechnicien" :items="technicienListe" hide-details
                style="text-transform: uppercase" multiple clearable>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index < 2" style="font-size: 12px">{{ item.title }}<span v-if="index === 0 && selectedTechnicien.length > 1">, </span></span>
                  <span v-if="index === 2" class="text-grey text-caption">
                    +{{ selectedTechnicien.length - 2 }}
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="etadlOptions.showAgencySelector" cols="12" sm="6" class="pa-1">
              <v-autocomplete variant="outlined" bg-color="#ECEFF1" density="compact" label="Agence"
                v-model="selectedAgency" :items="agency_list" hide-details item-title="ag_nom"
                style="text-transform: uppercase" no-data-text="Aucune agence" return-object>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pa-0 px-1">
          <v-checkbox density="compact" label="Interventions du jour uniquement"
            v-model="localVariable['showOnlyToday']" hide-details>
          </v-checkbox>
        </v-col>
        <v-col class="py-0 px-0" align="center">
          <!-- :style="{ height: getTableHeight }" -->
          <div v-if="getTabFilterByTech.length > 0 && selectedEtadl.length > 0"
            style="position: absolute; left: 10px; top: 10px; z-index: 3">
            <v-icon style="background-color: #e57373; border-radius: 5px" class="pa-4" color="white"
              @click="verifDeleteAll">mdi-delete</v-icon>
          </div>
          <Vue3EasyDataTable v-model:items-selected="selectedEtadl" table-class-name="customize-table" ref="dataTable"
            :headers="get_tab_header" :rows-per-page="nbrPagination" :items="getTabFilterByTech"
            style="overflow: auto; border-radius: 5px" :table-height="windowSize.height - 345"
            rows-per-page-message="Ligne par colonne" @click-row="openDialog" empty-message="Aucun contrat trouvé"
            hide-footer>
            <template #item-CLD_DESCRIPTION="item">
              <div>
                <span v-if="item.CLD_ETATDL_ALERT && item.CLD_ETATDL_ALERT.length > 0" class="mr-1">
                  <v-btn density="compact" v-if="item.CLD_ETATDL_ALERT.includes('mdi')" variant="tonal" color="green">
                    <v-icon>{{ item.CLD_ETATDL_ALERT }}</v-icon>
                  </v-btn>
                  <v-chip density="compact" v-else color="green" style="font-weight: bold;">
                    {{ item.CLD_ETATDL_ALERT }}
                  </v-chip>
                </span>
                {{ item.CLD_DESCRIPTION }}
              </div>
            </template>
            <template #header-CLD_DATE_DEPART="header">
              <div class="customize-header">
                {{ header.text }}
                <v-icon @click="
                  sortDateFilter == 1 ? (sortDateFilter = 2) : (sortDateFilter = 1)
                  " class="pa-2 mb-1 ml-1 sort" style="
                    font-size: 16px;
                    cursor: pointer;
                    border: solid 1px lightgrey;
                    border-radius: 100%;
                  ">
                  mdi-swap-vertical</v-icon>
              </div>
            </template>
            <template #header-CLD_DATE_RETOUR="header">
              <div class="customize-header">
                {{ header.text }}
                <v-icon @click="
                  sortDateFilter == 3 ? (sortDateFilter = 4) : (sortDateFilter = 3)
                  " class="pa-2 mb-1 ml-1 sort" style="
                    font-size: 16px;
                    cursor: pointer;
                    border: solid 1px lightgrey;
                    border-radius: 100%;
                  ">
                  mdi-swap-vertical</v-icon>
              </div>
            </template>
            <template #item-CLD_ACTION="item">
              <div style="display: flex; align-items: center; gap: 6px; padding: 4px 0; flex-wrap: wrap">
                <v-chip
                  size="small"
                  :class="getItemType(item.CLD_CONTROLE_DEPART, item.CLD_CONTROLE_RETOUR, item.CLD_WAITING).class"
                  style="color: black; font-weight: 600; font-size: 11px"
                >
                  {{ item.CLD_ACTION }}
                </v-chip>
                <v-tooltip
                  v-if="storedDataKeys && storedDataKeys.has(item.CLD_MATRICULE + '|' + item.CLD_NUM_CONTRAT + '|' + item.CLD_ID_CONTRAT_LOC_DATA)"
                  text="En attente de synchronisation" location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" size="20" color="#FB8C00">mdi-cloud-upload-outline</v-icon>
                  </template>
                </v-tooltip>
              </div>
            </template>
            <template #item-CLD_DATE_DEPART="item">
              <div class="customize-header">
                {{ formatDate(item.CLD_DATE_DEPART, "ll") }}
              </div>
            </template>
            <template #item-CLD_DATE_RETOUR="item">
              <div class="customize-header">
                {{ formatDate(item.CLD_DATE_RETOUR, "ll") }}
              </div>
            </template>
            <template #item-CLD_DATE_LIVRAISON_DEPART="item">
              <div class="customize-header">
                {{ formatDate(item.CLD_DATE_LIVRAISON_DEPART, "ll") }}
              </div>
            </template>
            <template #item-CLD_DATE_LIVRAISON_RETOUR="item">
              <div class="customize-header">
                {{ formatDate(item.CLD_DATE_LIVRAISON_RETOUR, "ll") }}
              </div>
            </template>
            <template #item-CLD_MODIFICATION="item">
              <div class="customize-header">
                {{ formatDate(item.CLD_MODIFICATION, "lll") }}
              </div>
            </template>
            <template #item-delete="item">
              <v-btn variant="text" color="#EF5350" density="compact" size="small"
                @click.stop="deleteEtadl({ value: true, data: item })">
                <v-icon size="22">mdi-delete-outline</v-icon>
              </v-btn>
            </template>
          </Vue3EasyDataTable>
          <v-pagination v-model="currentPaginationNumber" style="background-color: white" class="" rounded="circle"
            density="comfortable" :length="maxPaginationNumber"></v-pagination>
        </v-col>
      </v-card>
    </v-col>
    <v-col v-else>
      <v-col align="center" style="margin-top: 35vh">
        <v-progress-circular size="120" indeterminate color="black">Chargement</v-progress-circular>
      </v-col>
    </v-col>
    <v-snackbar v-model="snackbarData.value" :timeout="2000" :color="snackbarData.color">
      <div style="font-weight: bold">
        {{ snackbarData.text }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import materielForm from "./materielForm";
import modalUserDialog from "./modalUser";
import qcodeReader from "./qcodeReader";
import Vue3EasyDataTable from "vue3-easy-data-table";
import { ref } from "@vue/reactivity";
import homePageData from "../hooks/page-home";
import "vue3-easy-data-table/dist/style.css";
import { computed } from "@vue/runtime-core";
import moment from "moment";

export default {
  props: {
    windowSize: {},
  },
  setup() {
    const nbrPagination = ref(50);
    const currentPaginationNumber = ref(1);
    const page = ref(1);
    const pageCount = ref(0);
    const itemsPerPage = ref(15);
    const localVariable = ref({});

    const maxPaginationNumber = computed(function () {
      return Math.ceil(getTabFilterByTech.value.length / nbrPagination.value);
    });

    const getItemsMenuFiltered = computed(function () {
      return itemsMenu.filter((val) => val.idx != 1 && val.idx != 4);
    });

    const getTabFilterByTech = computed(function () {
      let ret = undefined;
      if (selectedTechnicien.value == undefined || selectedTechnicien.value.length == 0) {
        ret = get_tab_items.value;
      } else {
        ret = get_tab_items.value.filter((val) =>
          selectedTechnicien.value.includes(val.CLD_TECHNICIEN_DEPART.toUpperCase())
        );
      }
      if (localVariable.value && localVariable.value.showOnlyToday) {
        ret = ret.filter(
          (val) =>
            moment().isSame(moment(val.CLD_DATE_LIVRAISON_DEPART), "day") ||
            moment().isSame(moment(val.CLD_DATE_LIVRAISON_RETOUR), "day")
        );
      }

      return ret;
    });

    const {
      textColor,
      secondColor,
      selectedSubFamilly,
      rechercheFamille,
      selectedTechnicien,
      isLoading,
      isqCodeReaderOpen,
      dialog,
      modalUser,
      search,
      selectedItem,
      selectedMaterial,
      dialogData,
      materials_list,
      getSubFamilly,
      getFamilly,
      technicienListe,
      dataMenu,
      itemsMenu,
      get_client_state,
      get_tab_items,
      get_tab_header,
      get_selected_material_data,
      get_depart_material,
      get_waiting_material,
      get_return_material,
      get_user_information,
      isAdmin,
      clients_list,
      agency_list,
      defaultForm,
      defaultFormValues,
      getTableHeight,
      removeEtadlData,
      newMaterielData,
      nbrUploadDone,
      selectedAgency,
      etadlOptions,
      selectedEtadl,
      snackbarData,
      parcListe,
      deleteAllSelectedEtadl,
      getItemType,
      formatDate,
      setPhoto,
      uploadPhoto,
      deleteAllPhotos,
      updateTable,
      user,
      newMaterielForm,
      get_materials_data_to_show,
      closeDialog,
      updateCalendarDaysToShow,
      openDialog,
      setMaterialList,
      deleteEtadl,
      deleteEtadlValidation,
      getNbrPhotoToLoad,
      storedDataKeys,
      storageFullDialog,
      pendingMateriel,
      storageUsage,
      updateStorageUsage,
      syncProgress,
      syncSetItem,
      syncEnd,
      syncDeleteIndex,
      askRemoveStoredEtadl,
      cancelRemoveStoredEtadl,
      removeStoredEtadl,
    } = homePageData();

    return {
      snackbarData,
      nbrPagination,
      currentPaginationNumber,
      page,
      pageCount,
      itemsPerPage,
      textColor,
      secondColor,
      selectedSubFamilly,
      rechercheFamille,
      selectedTechnicien,
      isLoading,
      isqCodeReaderOpen,
      dialog,
      modalUser,
      search,
      selectedItem,
      selectedMaterial,
      dialogData,
      materials_list,
      getSubFamilly,
      getFamilly,
      technicienListe,
      dataMenu,
      itemsMenu,
      get_client_state,
      get_tab_items,
      get_tab_header,
      get_selected_material_data,
      get_depart_material,
      get_waiting_material,
      get_return_material,
      get_user_information,
      isAdmin,
      maxPaginationNumber,
      clients_list,
      agency_list,
      defaultForm,
      defaultFormValues,
      getTableHeight,
      removeEtadlData,
      newMaterielData,
      nbrUploadDone,
      getTabFilterByTech,
      selectedAgency,
      etadlOptions,
      selectedEtadl,
      parcListe,
      deleteAllSelectedEtadl,
      getItemType,
      formatDate,
      setPhoto,
      uploadPhoto,
      deleteAllPhotos,
      updateTable,
      user,
      newMaterielForm,
      get_materials_data_to_show,
      closeDialog,
      updateCalendarDaysToShow,
      openDialog,
      setMaterialList,
      deleteEtadl,
      deleteEtadlValidation,
      getNbrPhotoToLoad,
      storedDataKeys,
      storageFullDialog,
      pendingMateriel,
      storageUsage,
      updateStorageUsage,
      syncProgress,
      syncSetItem,
      syncEnd,
      syncDeleteIndex,
      askRemoveStoredEtadl,
      cancelRemoveStoredEtadl,
      removeStoredEtadl,
      getItemsMenuFiltered,
      localVariable,
    };
  },
  data() {
    return {
      isSavedModalOpen: false,
      isVerifAll: false,
    };
  },
  mounted() {
    this.localVariable["showOnlyToday"] = !this.etadlOptions.showOnlyToday;
    let query = this.$route.query;
    if (query.search) this.search = query.search;
  },
  components: {
    Vue3EasyDataTable,
    materielForm,
    modalUserDialog,
    qcodeReader,
  },
  watch: {
    currentPaginationNumber(val) {
      this.$refs["dataTable"].updatePage(val);
    },
  },
  methods: {
    async retrySaveAfterSync() {
      // Sync ce qui est en attente pour libérer de la place
      await this.sendSavedEtadlToServer();
      await this.updateStorageUsage();
      // Puis ré-essayer de sauvegarder l'état des lieux qui avait échoué
      if (this.pendingMateriel) {
        this.$store.commit('setStoredData', this.pendingMateriel);
        this.pendingMateriel = null;
        this.closeDialog();
      }
      this.storageFullDialog = false;
    },
    closeForm(rep) {
      console.log("closeForm", rep);

      this.dialog = false
      if (rep)
        this.updateTable()
    },
    async sendSavedEtadlToServer() {
      this.isLoading = true;
      this.isSavedModalOpen = false
      if (!navigator.onLine) {
        this.snackbarData = { value: true, text: "Pas de connexion internet", color: "orange" };
        this.isLoading = false;
        return;
      }

      // Copie pour éviter les problèmes d'itération si le store change
      let data = JSON.parse(JSON.stringify(this.$store.state.storedData));

      if (!data || data.length === 0) {
        this.isSavedModalOpen = false;
        this.isLoading = false;
        return;
      }

      try {
        for (let i = 0; i < data.length; i++) {
          data[i].isForced = true;
          // Affichage étape par étape : prépare la progression de cet état des lieux
          this.syncSetItem(i + 1, data.length, data[i]);
          await this.newMaterielForm(data[i], true, false); // callRefresh=false : pas de refresh entre chaque item
        }
        this.snackbarData = { value: true, text: "Synchronisation terminée", color: "green" };
        this.setMaterialList(); // un seul refresh à la fin, gère isLoading lui-même
      } catch (err) {
        console.error("Erreur synchronisation état des lieux :", err);
        this.snackbarData = { value: true, text: "Erreur lors de la synchronisation", color: "red" };
        this.isLoading = false;
      } finally {
        this.syncEnd(); // masque l'overlay de progression
        this.isSavedModalOpen = false;
      }
    },
    valideSuppression() {
      this.deleteAllSelectedEtadl();
      this.isVerifAll = false;
    },
    verifDeleteAll() {
      // deleteAllSelectedEtadl
      this.isVerifAll = true;
    },
    formatBytes(bytes) {
      if (!bytes) return '0 Mo';
      const mb = bytes / (1024 * 1024);
      return mb >= 1 ? `${mb.toFixed(0)} Mo` : `${(bytes / 1024).toFixed(0)} Ko`;
    },
    getMomentDiff(date) {
      return moment().diff(moment(date), "hours");
    },
    goToPath(href) {
      this.$router.push(href);
    },
  },
};
</script>

<style>
@import "../style.css";
</style>
